export default __webpack_public_path__ + "static/media/Q5-2.0eeb1b7c.jpg";